import React, { useEffect, useState } from 'react';
import { HeaderCard } from './headerCard';
import { Grid } from '@material-ui/core';
import { useApi, configApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { GroupMemberships, useUser } from '../../context/userContext';
import { squadNameFormat } from '../home/userCards/userFetch';

type UserContext = {
  apiVersion: string;
  kind: string;
  metadata: UserMetaData;
  relations: UserRelation[];
  spec: SpecData;
};

type SpecData = {
  type: string;
  owner: string;
  lifecycle: string;
};

type UserMetaData = {
  name: string;
  namespace: string;
  uid: string;
  etag: string;
  description: string;
  annotations: Annotations;
};

type Annotations = {
  'backstage.io/edit-url': string;
  'backstage.io/managed-by-location': string;
  'backstage.io/managed-by-origin-location': string;
  'backstage.io/source-location': string;
  'backstage.io/techdocs-ref': string;
  'backstage.io/view-url': string;
};

type UserRelation = {
  target: RelationTarget[];
  targetRef: string;
  type: string;
};

type RelationTarget = {
  kind: string;
  name: string;
  namespace: string;
};

export const TechdocsOwnedHeader = () => {
  const config = useApi(configApiRef);
  const baseURLforWidget = config.getOptionalString('backend.baseUrl');
  const { fetch: backstageFetch } = useApi(fetchApiRef);
  const [groupMemberships, setGroupMemberships] = useState<GroupMemberships[]>(
    [],
  );
  const [_catalogError, setCatalogError] = useState(null);
  const [catalogComponents, setCatalogComponents] = useState<UserContext[]>([]);
  const [hasMatch, setHasMatch] = useState(false);

  const { getUser } = useUser();

  useEffect(() => {
    const matchFound = catalogComponents.some(obj => {
      const squadName = squadNameFormat(obj.spec.owner);
      return groupMemberships.some(
        group => squadNameFormat(group.squad) === squadName,
      );
    });

    setHasMatch(matchFound);
  }, [catalogComponents, groupMemberships]);

  useEffect(() => {
    (async () => {
      const userData = await getUser();
      setGroupMemberships(userData.groupMemberships);
    })();
  }, [getUser]);

  useEffect(() => {
    (async () => {
      return await backstageFetch(
        `${baseURLforWidget}/api/catalog/entities?filter=metadata.annotations.backstage.io%2Ftechdocs-ref`,
      )
        .then(res => {
          if (!res.ok) throw new Error(`Catalog request failed: ${res.status}`);
          return res.json();
        })
        .then(json => {
          const returnArray: UserContext[] = json.flat();
          if (returnArray.length === 0) {
            return;
          }
          setCatalogComponents(returnArray);
        })
        .catch(err => {
          setCatalogError(err);
        });
    })();
  }, [groupMemberships, baseURLforWidget, backstageFetch]);

  const renderUserDocs = () => {
    return catalogComponents.map((obj, index) => {
      const squadName = squadNameFormat(obj.spec.owner);
      if (
        groupMemberships.some(group => {
          return squadNameFormat(group.squad) === squadName;
        })
      ) {
        const url = `/docs/default/component/${obj.metadata.name}`;
        return (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <HeaderCard
              key={index}
              title={obj.metadata.name}
              description={obj.metadata.description}
              url={url}
              actionTitle="View"
            />
          </Grid>
        );
      }
      return <></>;
    });
  };

  return (
    <>
      {hasMatch && <h2>My Documentation</h2>}
      <Grid container>{renderUserDocs()}</Grid>
    </>
  );
};
